import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../_ui/Modal/Modal';
import DialogContent from '@material-ui/core/DialogContent';
import './SelectDDOTranslate';
import { loadData, loadDataSC, selectDDoModule } from './SelectDDODucks';
import { Table } from '../ServiceProvidersModal/ServiceProvidersModalStyles';
import { changeFormValue } from '../../../passport/Passport';
import useDict from '../../../modules/_hooks/useDict';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

export default function SelectDDOModal({ close, metadataKey }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const loading = useSelector(state => state[selectDDoModule].loading);
  const data = useSelector(state => state[selectDDoModule].data);
  const validationMessages = useDict('validation_messages');
  const noPO = validationMessages.find(i => i.code === 'no_PO') || {};

  useEffect(() => {
    if (metadataKey === 'universal_voucher_queue_short') {
      dispatch(loadDataSC());
    } else {
      dispatch(loadData());
    }
  }, [dispatch, metadataKey]);

  return (
    <Modal
      open
      maxWidth="lg"
      scroll="paper"
      title={t('selectDDOModal_title')}
      onClose={close}
    >
      <DialogContent dividers>
        {data.length === 0 && !loading && (
          <div
            className="p2 flex mb2"
            style={{ backgroundColor: '#f8695e', color: 'white', borderRadius: 10 }}
          >
            <ErrorOutlineIcon color="inherit" />
            <div className="ml2">{noPO[`${i18n.language}_name`]}</div>
          </div>
        )}
        <Table
          loading={loading}
          columns={[
            {
              Header: t('serviceProviders_columnBin'),
              accessor: 'bin'
            },
            {
              Header: t('serviceProviders_columnName'),
              Cell: ({ original }) => original[`${i18n.language}_name`]
            }
          ]}
          data={data}
          onClickRow={({ original }) => {
            if (metadataKey === 'universal_voucher_queue_short') {
              changeFormValue(
                'request_form_universal_voucher_queue_short.choice_odo',
                original.ru_name
              );
              changeFormValue(
                'request_form_universal_voucher_queue_short.choice_odo_kk',
                original.kk_name
              );
              changeFormValue(
                'request_form_universal_voucher_queue_short.bin_odo',
                original.bin
              );
            } else {
              const formPrefix = 'request_form_doc_queued_ddo_short';
              changeFormValue(`${formPrefix}.choice_ddo`, original.ru_name);
              changeFormValue(`${formPrefix}.choice_ddo_kk`, original.kk_name);
              changeFormValue(`${formPrefix}.bin_ddo`, original.bin);
            }
            close();
          }}
        />
      </DialogContent>
    </Modal>
  );
}
